import { type ComponentPropsWithRef, forwardRef, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type FieldLabelProps = ComponentPropsWithRef<'label'>;

export const FieldLabel = memo(
  forwardRef<HTMLLabelElement, FieldLabelProps>(({ children, className, htmlFor, ...restOfProps }, forwardedRef) => {
    return (
      <label
        className={cn(
          'font-medium ads:text-secondary text-12 text-gray-11',
          htmlFor ? 'cursor-pointer' : 'cursor-auto',
          className,
        )}
        htmlFor={htmlFor}
        ref={forwardedRef}
        {...restOfProps}
      >
        {children}
      </label>
    );
  }),
);

FieldLabel.displayName = 'FieldLabel';
